import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import style from "./MenuBarAdmin.module.css";
import logo from "../Star/assets/logo.png";
import { useLocation } from "react-router-dom";
const MenuBar = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const mode = params.get("mode");

    if (mode) {
      sessionStorage.setItem("mode", mode.toLowerCase());
    }
  }, []);
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const mode = (sessionStorage.getItem("mode") || "").toLowerCase();
  const isEmbedded = mode === "embedded" || mode === "admin";
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 992);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 992);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <>
      {/* Show toggle button only on mobile */}
      {isMobile && (
        <button className={style.toggleBtn} onClick={toggleMenu}>
          {menuOpen ? "☰" : "☰"}
        </button>
      )}

      {/* Sidebar */}
      <div
        className={`${style.MenuBar} ${isMobile
          ? menuOpen
            ? style.menuOpen
            : style.menuClosed
          : style.desktopMenu
          }`}
      >
        {!isEmbedded && (
          <div className={style.menulogo}>
            <img src={logo} alt="Logo" style={{ height: "40px" }} />
          </div>
        )}
        <div className={style.MenuBarContainer}>
          <NavLink
            to="/asnstatus"
            className={({ isActive }) =>
              isActive ? `${style.link} ${style.active}` : style.link
            }
          >
            ASN Status
          </NavLink>

          {/* <NavLink
            to="/openpo"
            className={({ isActive }) =>
              isActive ? `${style.link} ${style.active}` : style.link
            }
          >
            Open PO
          </NavLink> */}
        </div>
      </div>
    </>
  );
};

export default MenuBar;
